
// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { filtersUserStatuses } from '../statuses';

export default class FiltersUsersPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'filtersUsers';
        this.Server = this.props.context.getState().server.filtersUsers;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['email', 'phone', 'status'];
        this.showDatePicker = false;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'email',
                    label: 'email',
                    alignRight: false,
                    cell: 'Tags',
                    type: 'tags',
                    displayGrid: true,
                    validation: 'email'
                },
                {
                    id: 'phone',
                    label: 'phone',
                    alignRight: false,
                    cell: 'Tags',
                    type: 'tags',
                    displayGrid: true,
                    validation: 'phone'
                },
                {
                    id: 'status',
                    label: 'status',
                    alignRight: false,
                    cell: 'State',
                    items: Object.keys(filtersUserStatuses),
                    displayGrid: true
                },
                {
                    id: 'totalSuccess',
                    label: 'totalSuccess',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'totalCancelled',
                    label: 'totalCancelled',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                }
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

